function notNull<TYPE>(sth: TYPE | null): sth is TYPE {
    return sth !== null
}

export default notNull
